export var TimeFrameSubjects;
(function (TimeFrameSubjects) {
    TimeFrameSubjects["TimeFrameIconInSync"] = "loaded";
    TimeFrameSubjects["TimeFrameLoadingIcon"] = "loading";
})(TimeFrameSubjects || (TimeFrameSubjects = {}));
//# sourceMappingURL=time-frame.enum.js.map